var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-btn',{on:{"click":_vm.reloadRules}},[_vm._v("Reload rules")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }